import * as React from "react";
import './backBtn.css';
import {Cookies} from "react-cookie";
import {formStores} from "../../scenes/Forms/state/mobx";
import {FormComponent} from "../../scenes/Forms/state/FormsState";
import MixPanelAnalyticsService from "../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsSignUpEvents} from "../../services/Analytics/AnalyticsSignUpEvents";

const signUpStore = formStores.formStore;
export default class ResetFormBtn  extends React.Component {
    public reset = () => {
        if(confirm("Are you sure you would like to restart the application?  \n if you do, all of the information you have provided thus far will be deleted")) {
            const cookies = new Cookies();
            cookies.remove('uid');
            signUpStore.formInput = {};
            signUpStore.resetUser();
            MixPanelAnalyticsService.track(AnalyticsSignUpEvents.StartOver);
            signUpStore.updateCurrentComponent(FormComponent.welcome);
        }
    };

    public render() {
        return (
            <div className="link-back" onClick={this.reset}>
                <div className="back-text" >Start over</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ResetForm/resetFormBtn.tsx